import React from 'react'
import { connect } from 'react-redux'
import { Alert, Button, Col, Divider, message, Progress, Row, Spin, Table, Upload } from 'antd'
import { FileSyncOutlined, FileTextFilled, UploadOutlined } from '@ant-design/icons'

import '../../asset/less/NewPieces.css'
import { ExcelRenderer } from 'react-excel-renderer'
import moment from 'moment'
import { patchArtwork } from '../../api/artworks'
import { patchArtworkConfig } from '../../api/artworkConfigs'
import HttpError from '../../component/base/HttpError'
import FormButton from '../../component/base/FormButton'
import Modal from 'antd/es/modal/Modal'
import Sheets from '../../asset/file/revart_artwork_sheets_template_23_01_03.xlsx'

@connect((state) => ({
  userId: state.user.info.id,
  email: state.user.info.email,
  role: state.user.info.role,
  artists: state.artist.artists
}))
class ImportArtworkSheets extends React.Component {
  constructor(props) {
    super(props)
    this.expoFormRef = React.createRef()
    this.state = {
      loading: false,
      updateBtnEnabled: false,
      selectNameId: [],
      dataSource: [],
      rows: [],
      cols: [],
      promiseResults: [],
      successPromiseNum: 0,
      totalPromiseNum: 0,
      progressVisible: false,
      templateType: 0
    }
  }

  componentDidMount() {}

  onChange = (info) => {
    if (info.file.status === 'done') {
      this.setState({
        updateBtnEnabled: true,
        loading: false
      })
      message.success(`${info.file.name} file uploaded successfully`).then((r) => {})
    } else if (info.file.status === 'error') {
      this.setState({
        updateBtnEnabled: false,
        loading: false
      })
      message.error(`${info.file.name} file upload failed.`).then((r) => {})
    }
  }

  handleUpload = (f, onSuccess) => {
    ExcelRenderer(f, (err, resp) => {
      if (err) {
        message.error(err).then((r) => {})
      } else {
        let rows = resp.rows.filter((v) => {
          return v.length !== 0
        })
        const titles = rows[0]
        if (titles.length === 23) {
          // from template
          this.setState({
            templateType: 1
          })
        }
        const columns = titles.map((item, idx) => {
          return {
            title: item,
            dataIndex: idx,
            key: idx,
            render: (text, record, index) => (
              <span
                style={{
                  display: 'block',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {text}
              </span>
            )
          }
        })
        rows.shift()
        const data = rows.map((item, idx) => {
          const obj = {}
          for (let i = 0; i < item.length; i++) {
            if (item[i]) obj[i] = String(item[i]).trim()
          }
          return obj
        })
        this.setState({
          cols: columns,
          dataSource: data,
          rows: rows
        })
      }
      onSuccess()
    })
  }

  handleUpdate = () => {
    this.setState({
      progressVisible: false,
      loading: true
    })

    function checkIfTrue(true_str) {
      if (!true_str) return false
      true_str = true_str.toLowerCase()
      return true_str === 'true' || true_str === 'y' || true_str === 'yes'
    }

    function sanity_str(str) {
      if (!str) return str
      str = str.trim()
      str = str.toLowerCase()
      return str.replace(' ', '-')
    }

    let postTasks = []
    let artwork_ids = []
    let progressLayout = []

    this.state.rows.map((v) => {
      if (v.length === 0) return
      const i = 0
      let skuNum = ''
      let artworkName = ''
      let copy_num = ''
      let width = ''
      let height = ''
      let depth = ''
      let year = ''
      let style_type_str = ''
      let medium_type_str = ''
      let material_type_str = ''
      let content_info_str = ''
      let label_str = ''
      let is_sell = ''
      let price_type_str = ''
      let is_framed = ''
      let is_commission = ''
      let is_prints = ''
      let is_liscence = ''
      let extra_info_str = ''
      let prints_num = null
      let prints_markup_percentage = null
      let size_desc_str = ''

      if (this.state.templateType === 1) {
        skuNum = v[i + 1]
        artworkName = v[i + 4]
        copy_num = v[i + 5]
        width = v[i + 6]
        height = v[i + 7]
        depth = v[i + 8]
        year = v[i + 9]
        style_type_str = sanity_str(v[i + 10])
        medium_type_str = sanity_str(v[i + 11])
        material_type_str = v[i + 12]
        content_info_str = sanity_str(v[i + 13])
        label_str = v[i + 14]
        is_sell = v[i + 15]
        price_type_str = v[i + 16]
        is_framed = v[i + 17]
        is_commission = v[i + 18]
        is_prints = v[i + 19]
        is_liscence = v[i + 20]
        extra_info_str = v[i + 21]
        size_desc_str = v[i + 24]
        try {
          prints_num = parseInt(v[i + 25])
          if (prints_num < 0) prints_num = null
        } catch (e) {}

        try {
          prints_markup_percentage = parseInt(v[i + 26])
          if (prints_markup_percentage <= 0 || prints_markup_percentage > 100) prints_markup_percentage = null
        } catch (e) {}
      } else {
        skuNum = v[i]
        artworkName = v[i + 1]
        copy_num = v[i + 2]
        width = v[i + 3]
        height = v[i + 4]
        depth = v[i + 5]
        year = v[i + 6]
        style_type_str = sanity_str(v[i + 7])
        medium_type_str = sanity_str(v[i + 8])
        material_type_str = v[i + 9]
        content_info_str = sanity_str(v[i + 10])
        label_str = v[i + 11]
        is_sell = v[i + 12]
        price_type_str = v[i + 13]
        is_framed = v[i + 14]
        is_commission = v[i + 15]
        is_prints = v[i + 16]
        is_liscence = v[i + 17]
        extra_info_str = v[i + 18]
        size_desc_str = v[i + 21]
        try {
          prints_num = parseInt(v[i + 22])
          if (prints_num < 0) prints_num = null
        } catch (e) {}

        try {
          prints_markup_percentage = parseInt(v[i + 23])
          if (prints_markup_percentage <= 0 || prints_markup_percentage > 100) prints_markup_percentage = null
        } catch (e) {}
      }

      let used_type = []

      if (checkIfTrue(is_sell)) {
        used_type.push('original')
      }
      if (checkIfTrue(is_commission)) {
        used_type.push('commission')
      }
      if (checkIfTrue(is_prints)) {
        used_type.push('prints')
      }
      if (checkIfTrue(is_liscence)) {
        used_type.push('licensing')
      }

      let isCreate = false
      if (!skuNum) {
        isCreate = true
      } else {
        artwork_ids.push(skuNum)
      }
      const artworkParam = {
        name: artworkName,
        year: year,
        s3_url: 's3_url',
        static_url: 'static_url',
        file_size: 0,
        used_type: used_type.length === 0 ? '' : used_type?.join(','),
        copy_num: copy_num !== '' ? copy_num : 0,

        label_str: label_str,
        medium_type_str: medium_type_str,
        material_type_str: material_type_str,
        size_type_str: height + ',' + width + ',' + depth,
        frame_size_h: height,
        frame_size_w: width,
        frame_size_d: depth,
        size_desc_str: size_desc_str,
        price_type_str: price_type_str,
        style_type_str: style_type_str,
        extra_info_str: extra_info_str,
        content_info_str: content_info_str
      }
      const user_created_date = moment(`${year}-${'01'}-${'01'}`, 'YYYY-MM-DD').format('YYYY-MM-DD')
      const artworkConfigParam = {
        is_visible_gallery: true,
        is_display_watermark: false,
        is_framed: is_framed,
        is_for_sale: checkIfTrue(is_sell),
        frame_size_h: height,
        frame_size_w: width,
        frame_size_d: depth,
        frame_desc: '',
        inventory_prints_quantity: prints_num,
        prints_markup_percentage: prints_markup_percentage,
        user_created_date
      }
      if (isCreate) {
        // postTasks.push(
        //     postArtworkAdmin({artist: name_id[0].id, ...artworkParam})
        //         .then(async (response) => {
        //             await postArtworkConfig({
        //                 artwork: response.data.id,
        //                 ...artworkConfigParam,
        //             });
        //         })
        //         .catch((error) => {
        //             HttpError(error)
        //         })
        // )
      } else {
        delete artworkParam['s3_url']
        delete artworkParam['static_url']
        postTasks.push(
          patchArtwork(parseInt(skuNum), artworkParam)
            .then(async (response) => {
              await patchArtworkConfig(response.data.id, artworkConfigParam)
              return (
                <Row>
                  <Col span={2}>
                    <span># {response.data.id} </span>
                  </Col>
                  <Col span={22}>
                    <Progress percent={100} size='small' />
                  </Col>
                </Row>
              )
            })
            .catch((error) => {
              return (
                <Row>
                  <Col span={2}>
                    <span># {parseInt(skuNum)} </span>
                  </Col>
                  <Col span={20}>
                    <Progress status='exception' percent={100} size='small' />
                  </Col>
                  <Col span={2}>
                    <a target={'_blank'} href={'/sam/pieces/edit/' + parseInt(skuNum)} rel='noreferrer'>
                      View
                    </a>
                  </Col>
                  <Col span={24}>
                    <p>{error.toString() + ' ' + error.response?.toString()}</p>
                    <Alert message={'check the sku# ' + parseInt(skuNum) + ' is correct. or contact us it@revart.co'} type='info' />
                  </Col>
                </Row>
              )
            })
        )
      }
    })

    Promise.all(postTasks)
      .then((p) => {
        progressLayout.push(p)
        this.setState({
          promiseResults: progressLayout,
          loading: false,
          totalPromiseNum: postTasks.length
        })
      })
      .catch((e) => {
        HttpError(e)
      })

    this.setState({
      promiseResults: progressLayout,
      progressVisible: true
    })
  }

  customRequest = (options) => {
    const { onSuccess, file } = options
    this.setState({
      loading: true
    })
    this.handleUpload(file, onSuccess)
  }

  handleArtistSelect = (v) => {
    const tmp = []
    v.map((v) => {
      tmp.push(v)
    })
    this.setState({
      selectNameId: tmp
    })
  }

  showProgressModal = () => {
    this.setState({ progressVisible: true })
  }

  render() {
    function getUpdateButton(state, func) {
      if (state.updateBtnEnabled) {
        return (
          <Button
            block
            icon={<FileSyncOutlined />}
            type='primary'
            size='large'
            onClick={() => {
              func()
            }}
          >
            Update Pieces
          </Button>
        )
      } else {
        return (
          <Button
            disabled
            icon={<FileSyncOutlined />}
            block
            type='primary'
            size='large'
            onClick={() => {
              func()
            }}
          >
            Update Pieces
          </Button>
        )
      }
    }

    function showResultLayout(instance) {
      return (
        <Modal
          title='Artwork Pieces Update Progress'
          centered
          visible={instance.state.progressVisible}
          onCancel={() => {
            instance.setState({ progressVisible: false })
          }}
          footer={null}
          width={1000}
        >
          <div style={{ overflow: 'auto', height: 400 }}>
            <p>Update {instance.state.totalPromiseNum} artwork pieces</p>
            <Spin size='large' style={{ marginTop: 20 }} spinning={instance.state.loading}>
              {instance.state.promiseResults}
            </Spin>
          </div>
        </Modal>
      )
    }

    return (
      <Spin size='large' spinning={this.state.loading}>
        <Divider orientation='left'>Info Sheets Template</Divider>
        <Button type={'link'} href={Sheets} target={'_blank'} icon={<FileTextFilled />}>
          Download the excel sheet template
        </Button>
        <Alert
          message='Notes'
          description='1. The first row of the template is dummy data, please remove it before your uploading.
                  2. Sku# is a unique id required by RevArt, so please make sure it is correct with your artwork pieces.'
          type='info'
          showIcon
        />
        <Divider orientation='left'>Artwork Info Upload Panel</Divider>
        <Upload maxCount={1} name='fileexcel' customRequest={this.customRequest} onChange={this.onChange}>
          <Button icon={<UploadOutlined />}>Click to upload the excel sheet</Button>
        </Upload>

        <Table
          scroll={{ x: 1300 }}
          pagination={{
            pageSize: 10
          }}
          columns={this.state.cols}
          dataSource={this.state.dataSource}
        />
        <FormButton>
          <>
            <Col span={12} offset={6}>
              {getUpdateButton(this.state, this.handleUpdate)}
            </Col>
          </>
        </FormButton>
        {showResultLayout(this)}
      </Spin>
    )
  }
}

export default ImportArtworkSheets
